// Global packages and components
import { Link } from '@remix-run/react'
import {
  Slider,
  Heading,
  Image,
  SchemaWrapper,
  SchemaMeta,
  SchemaElement,
} from '~/components'

// Types
import type { CustomCategoryProps } from '~/types'

interface BlockCategoryCarouselProps {
  title: string
  items: CustomCategoryProps[]
}

// Main export
export default function BlockCategoryCarousel({
  title,
  items,
}: BlockCategoryCarouselProps) {
  return (
    <SchemaWrapper
      type="ItemList"
      className="container"
    >
      {title && (
        <>
          <Heading
            className="mb-10 text-center"
            tag="h2"
            size="h4"
          >
            {title}
          </Heading>
          <SchemaMeta
            prop="name"
            content={title}
          />
        </>
      )}
      {items && items.length !== 0 && (
        <Slider
          options={{
            perPage: 2,
            gap: '1rem',
            breakpoints: {
              768: {
                perPage: 3,
                gap: '2rem',
              },
              1024: {
                perPage: 4,
                gap: '2rem',
              },
              1280: {
                perPage: 5,
                gap: '2rem',
              },
              1536: {
                perPage: 6,
                gap: '2rem',
              },
            },
          }}
        >
          {items.map((e, i) => (
            <SchemaWrapper
              as={Link}
              key={i}
              type="ListItem"
              prop="itemListElement"
              to={`/${e?.type}/c/${e?.slug?.current}`}
              className="group"
            >
              <SchemaMeta
                prop="position"
                content={String(i + 1)}
              />
              <SchemaWrapper
                as="span"
                type="OfferCatalog"
                prop="item"
                className="contents"
              >
                {e?.icon?.asset && (
                  <Image
                    image={e.icon}
                    customSize={350}
                    className="mx-auto mb-3 block transition-transform group-hover:scale-95"
                  />
                )}
                {e?.title && (
                  <h5 className="text-center font-semibold">
                    <SchemaElement
                      prop="name"
                    >
                      {e.title}
                    </SchemaElement>
                  </h5>
                )}
              </SchemaWrapper>
            </SchemaWrapper>
          ))}
        </Slider>
      )}
    </SchemaWrapper>
  )
}
